module.exports = __webpack_public_path__ + "static/Twilio3-c337c3b27910d0fe59d4757e1250da77.png";